import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePolicyAdjustments } from '../../actions/policy/reducePolicyAdjustments';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getPolicyAdjustmentsSaga() {
    try {
        yield put(reduceLoading({ code: 'getPolicyAdjustments', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(fetch, `/api/policyAdjustment/${entity}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            console.error('Get Policy Adjustments API failed with status:', response.status);
            yield put(reduceLoading({ code: 'getPolicyAdjustments', value: false }));
            return;
        }

        const result = yield call([response, 'json']);

        // Add operation code to identify which operation completed
        yield put(reduceOperation({ ...result.operation, code: 'getPolicyAdjustments' }));
        yield put(reducePolicyAdjustments(result));
        yield put(reduceLoading({ code: 'getPolicyAdjustments', value: false }));
    } catch (error) {
        console.log('Error while calling Get Policy Adjustments API - ', error);
        yield put(reduceLoading({ code: 'getPolicyAdjustments', value: false }));
    } finally {
        yield put(reduceLoading({ code: 'getPolicyAdjustments', value: false }));
    }
}
